import { DeviceType } from '@/src/types'
import { handleApiError } from '@/src/utils/errorHandler'
import { apiGetHelper, apiPutOrPostHelper } from '../helperFunctions'
import { AxiosResponse } from 'axios'
import { logError } from '@/src/utils/logError'
import { ERROR_MESSAGES, getMessageForEndpoint } from '@/src/constants/error'

interface ApiOptions {
    skipErrorHandling?: boolean
    requestHeaders?: object
    contentType?: string
}

export async function get<T>(
    URL: string,
    deviceType: DeviceType,
    options: ApiOptions = {}
): Promise<AxiosResponse<T>> {
    const { skipErrorHandling = false, requestHeaders, contentType } = options

    try {
        const response = await apiGetHelper({
            URL,
            contentType,
            requestHeaders,
            deviceType,
            skipErrorHandling
        })

        return response as AxiosResponse<T>
    } catch (e) {
        logError('ApiService ', e)

        // Get endpoint-specific error message
        const errorMessage = getMessageForEndpoint(URL, 'GET')

        // Always handle API errors, but don't handle them twice
        if (!skipErrorHandling) {
            handleApiError(e, errorMessage)
        }
        throw e
    }
}

export async function request<T>(
    URL: string,
    payload: object = {},
    deviceType: DeviceType,
    method: 'post' | 'put' = 'post',
    options: ApiOptions = {}
): Promise<AxiosResponse<T>> {
    const { skipErrorHandling = false, requestHeaders, contentType } = options

    try {
        const response = await apiPutOrPostHelper({
            URL,
            payload,
            contentType,
            requestHeaders,
            method,
            deviceType,
            skipErrorHandling
        })

        return response as AxiosResponse<T>
    } catch (e) {
        logError('ApiService ', e)

        // Get endpoint-specific error message
        const errorMessage = getMessageForEndpoint(URL, method.toUpperCase())

        if (!skipErrorHandling) {
            handleApiError(e, errorMessage)
        }
        throw e
    }
}
